import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavigateButton } from './NavigateButton';

type Props = {
  pathPrefix?: string;
  id: string;
  params?: string;
};

export const NavigateDetailsButton: FC<Props> = ({
  pathPrefix,
  id,
  params,
}) => {
  const { t } = useTranslation();

  return (
    <NavigateButton
      type="default"
      path={`${pathPrefix ? `${pathPrefix}/` : ''}${id}${params ? `?${params}` : ''}`}
      text={t('details')}
    />
  );
};
